import React from "react";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

/** Sticky floating WhatsApp CTA — visible from every page.
 *  The clinic owner wants the easiest possible path: every visitor should be
 *  one tap away from messaging the clinic directly. */
const CLINIC_WA_E164 = "+447445372190";

const DEFAULT_MSGS = {
  en: "Assalāmu ʿalaykum, I would like to ask a question about Islamic Cure & Care.",
  ar: "السلام عليكم، أود الاستفسار عن خدمات العلاج الإسلامي والرعاية.",
  ur: "السلام علیکم، میں اسلامک کیور اینڈ کیئر کے بارے میں ایک سوال کرنا چاہتا ہوں۔",
  de: "Assalāmu ʿalaykum, ich möchte eine Frage zu Islamic Cure & Care stellen.",
  fr: "Assalāmu ʿalaykum, je souhaiterais poser une question sur Islamic Cure & Care.",
};

const LABELS = {
  en: "Chat on WhatsApp",
  ar: "تواصل عبر واتساب",
  ur: "واٹس ایپ پر بات کریں",
  de: "Auf WhatsApp chatten",
  fr: "Discuter sur WhatsApp",
};

const FloatingWhatsApp = () => {
  const { lang } = useLanguage();
  const msg = encodeURIComponent(DEFAULT_MSGS[lang] || DEFAULT_MSGS.en);
  const href = `https://wa.me/${CLINIC_WA_E164.replace("+", "")}?text=${msg}`;
  const label = LABELS[lang] || LABELS.en;

  return (
    <a
      data-testid="floating-whatsapp-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      title={label}
      className="fixed bottom-5 right-5 z-50 group inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white font-medium pl-4 pr-5 py-3 rounded-full shadow-2xl shadow-black/20 transition-all hover:-translate-y-0.5"
      style={{ direction: "ltr" }}
    >
      <span className="relative flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-60"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
      </span>
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm whitespace-nowrap">{label}</span>
    </a>
  );
};

export default FloatingWhatsApp;
